import {
  DEFAULT_PERMISSIONS_MANAGEMENT_FILTERS,
  PermissionsManagementFilters,
} from "./permissionsManagementFilters.types";

export const hasActivePermissionsManagementFilters = (
  filters: PermissionsManagementFilters,
): boolean =>
  filters.searchTerm.trim().length > 0 ||
  filters.roleFilters.length > 0 ||
  filters.permissionsFilters.length > 0;

export const clearPermissionsManagementFilters =
  (): PermissionsManagementFilters => ({
    ...DEFAULT_PERMISSIONS_MANAGEMENT_FILTERS,
  });
